// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Player {
	position: absolute;
	display: flex;
	flex-direction: row;
	align-items: center;
	height: 50px;
	bottom: 0;
	width: 10vw;
	transition: 2s;
	justify-content: left;
}

.Player img {
	height: 40px;
	aspect-ratio: 1;
	border-radius: 50%;
	object-fit: cover;
}

.Player:hover img {
	height: 80%;	
}

.Player h1 {
	color: white;
	font-size: 1.1em;
	/*background: #ffffff8a;
	padding: 5px;*/
}
`, "",{"version":3,"sources":["webpack://./src/components/Player.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,YAAY;CACZ,SAAS;CACT,WAAW;CACX,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB;eACc;AACf","sourcesContent":[".Player {\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\theight: 50px;\n\tbottom: 0;\n\twidth: 10vw;\n\ttransition: 2s;\n\tjustify-content: left;\n}\n\n.Player img {\n\theight: 40px;\n\taspect-ratio: 1;\n\tborder-radius: 50%;\n\tobject-fit: cover;\n}\n\n.Player:hover img {\n\theight: 80%;\t\n}\n\n.Player h1 {\n\tcolor: white;\n\tfont-size: 1.1em;\n\t/*background: #ffffff8a;\n\tpadding: 5px;*/\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
